"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentCreatedBy = exports.WarehouseShipmentCancellationReason = exports.WarehouseShipmentStatus = void 0;
var WarehouseShipmentStatus;
(function (WarehouseShipmentStatus) {
    WarehouseShipmentStatus["CREATED"] = "CREATED";
    WarehouseShipmentStatus["ON_HOLD"] = "ON_HOLD";
    WarehouseShipmentStatus["PROCESSING"] = "PROCESSING";
    WarehouseShipmentStatus["READY_TO_SHIP"] = "READY_TO_SHIP";
    WarehouseShipmentStatus["SHIPPED"] = "SHIPPED";
    WarehouseShipmentStatus["CANCELLED"] = "CANCELLED";
    WarehouseShipmentStatus["PARTIALLY_SHIPPED"] = "PARTIALLY_SHIPPED";
})(WarehouseShipmentStatus = exports.WarehouseShipmentStatus || (exports.WarehouseShipmentStatus = {}));
var WarehouseShipmentCancellationReason;
(function (WarehouseShipmentCancellationReason) {
    WarehouseShipmentCancellationReason["STOCKOUT"] = "STOCKOUT";
    WarehouseShipmentCancellationReason["WEATHER"] = "WEATHER";
    WarehouseShipmentCancellationReason["CAPACITY"] = "CAPACITY";
    WarehouseShipmentCancellationReason["LABEL_ERROR"] = "LABEL_ERROR";
    WarehouseShipmentCancellationReason["DAMAGED"] = "DAMAGED";
    WarehouseShipmentCancellationReason["DELIVERR_CANCELLED"] = "DELIVERR_CANCELLED";
    WarehouseShipmentCancellationReason["PACKAGING"] = "PACKAGING";
    WarehouseShipmentCancellationReason["INTL_SHIPMENT"] = "INTERNATIONAL_SHIPMENT";
    WarehouseShipmentCancellationReason["OTHER"] = "OTHER";
})(WarehouseShipmentCancellationReason = exports.WarehouseShipmentCancellationReason || (exports.WarehouseShipmentCancellationReason = {}));
var ShipmentCreatedBy;
(function (ShipmentCreatedBy) {
    ShipmentCreatedBy["FULFILLMENT"] = "FULFILLMENT";
    ShipmentCreatedBy["WHOLESALE"] = "WHOLESALE";
})(ShipmentCreatedBy = exports.ShipmentCreatedBy || (exports.ShipmentCreatedBy = {}));
//# sourceMappingURL=WarehouseShipment.js.map